import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseFestivalManagment } from "./UseFestivalManagment";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export default function AddFestival(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const { createFestival, validate } = UseFestivalManagment();
  const { isSmall } = useBreakpoints();
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const { toSolar } = require("jdate-convert");

  const [state, setState] = useState({
    title: undefined,
    startDate: undefined,
    endDate: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    startDate: false,
    endDate: false,
  });

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, startDate: newValueStart });
  }, [valueStart]);

  useEffect(() => {
    let newValueEnd = valueEnd?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, endDate: newValueEnd });
  }, [valueEnd]);

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/festivalmanagment" },
          { name: "افزودن جشنواره", url: "/festivalmanagment/addFestival" },
        ],
      }}
    >
      {state ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            sx={{ display: "flex", gap: 2 }}
            gridColumn={isSmall ? "span 12" : "span 7"}
          >
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              onChange={setValueStart}
              value={state && state.startDate ? toSolar(state.startDate) : ""}
              render={
                <TextField
                  sx={{ pr: 2, input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ شروع"
                  error={errorState.startDate}
                />
              }
            />
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={state && state.endDate ? toSolar(state.endDate) : ""}
              // value={valueEnd}
              onChange={setValueEnd}
              render={
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  label="تاریخ پایان"
                  size="small"
                  fullWidth
                  error={errorState.endDate}
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  createFestival(state, () => {
                    navigate("/festivalmanagment", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/festivalmanagment", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
